

























import { Vue, Component, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { title as respectTitle, content as respectContent } from '~/static/content/respect.js';

import MarkdownContainer from '~/components/partials/MarkdownContainer.vue';

@Component({
  components: { MarkdownContainer },
  middleware: [
    'noauth',
  ],
  computed: {
    ...mapState('lang', [
      'locale',
    ]),
  },
  head () {
    const self: any = this;
    const description = self.content.match(new RegExp('<p>' + "(.*)" + '</p>'));
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.title} - On Piste`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description ? description[0].trim().replace(/<\/?[^>]+(>|$)/g, "") : '',
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.title} - On Piste`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description ? description[0].trim().replace(/<\/?[^>]+(>|$)/g, "") : '',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: `https://www.onpiste.com/img/corporate/respect_banner.jpg`,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}respect`,
        },
      ],
    };
  },
  fetch () {
    const self: any = this;
    self.getElements();
  },
})
export default class Respect extends Vue {
  locale: string;

  title: string = '';
  content: string = '';
  respectTitle: {[key: string]: string} = respectTitle;
  respectContent: {[key: string]: string} = respectContent;

  /* This method will get the right local content based on store locale */
  @Watch('locale')
  getElements () {
    this.title = this.respectTitle[this.locale] || this.respectTitle['en'];
    this.content = this.respectContent[this.locale] || this.respectContent['en'];
  }
}
